import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'

export class MTNAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);


        this.columns = [
            {
                key: `dates`,
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            },
            {
                key: `mTotalHits`,
                TrOnlyClassName: 'tsc',
                text: "Total Hits",
                className: "tsc",
                align: "left"
            },
            {
                key: "mTotalDepositsAttempted",
                TrOnlyClassName: 'tsc',
                text: "Total Deposits Attempted",
                className: "tsc",
                align: "left"
            },
            {
                key: "SUM(SuccessfulHits)",
                TrOnlyClassName: 'tsc',
                text: "Successful Hits",
                className: "tsc",
                align: "left"
            },

            {
                key: "mSuccessfulDeposits",
                TrOnlyClassName: 'tsc',
                text: "SuccessfulDeposits",
                className: "tsc",
                align: "left"
            },
            {
                key: "mSuccessful",
                TrOnlyClassName: 'tsc',
                text: "%-Successful",
                className: "tsc",
                align: "left"
            },
            {
                key: "FailedHits",
                TrOnlyClassName: 'tsc',
                text: "Failed Hits",
                className: "tsc",
                align: "left"
            },
            {
                key: "mFailedDeposits",
                TrOnlyClassName: 'tsc',
                text: "Failed Deposits",
                className: "tsc",
                align: "left"
            },

            {
                key: "mInsufficientFunds",
                TrOnlyClassName: 'tsc',
                text: "%-InsufficientFunds",
                className: "tsc",
                align: "left"
            },
            {
                key: "CancelledHits",
                TrOnlyClassName: 'tsc',
                text: "SUM(CancelledHits)",
                className: "tsc",
                align: "left"
            },
            {
                key: "totalCancelledDeposits",
                TrOnlyClassName: 'tsc',
                text: "SUM(CancelledDeposits)",
                className: "tsc",
                align: "left"
            },
            {
                key: "perCancelledDeposits",
                TrOnlyClassName: 'tsc',
                text: "%-CancelledDeposits",
                className: "tsc",
                align: "left"
            },
            {
                key: "InitiatedHits",
                TrOnlyClassName: 'tsc',
                text: "SUM(InitiatedHits)",
                className: "tsc",
                align: "left"
            },
            {
                key: "mInitiatedDeposits",
                TrOnlyClassName: 'tsc',
                text: "SUM(InitiatedDeposits)",
                className: "tsc",
                align: "left"
            },

            {
                key: "mTimedOutDeposits",
                TrOnlyClassName: 'tsc',
                text: "%-TimedOutDeposits",
                className: "tsc",
                align: "left"
            }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: false,
            pagination: 'advance',
            page_size: 100,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
        let now = new Date();
        let start = moment.utc(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment.utc(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end,
            isPageLoad: true,
        }
    }
    componentDidMount() {
        this.setState({
            startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            isPageLoad: true,
            valuedate: "Today"
        })

        this.getData(moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    getData = (startDate, endDate) => {

        let url = baseURL + `mtnanalysis?startDate="${startDate}"&endDate="${endDate}"`;
        console.log("query", url);
        this.setState({
            isLoading: true,
        })
        axios.all([
            axios.get(url),
        ]).then(axios.spread((mtnAnalysisResponse,) => {
            this.setState({
                mtnAnalysis: mtnAnalysisResponse.data,
                // mdata: entityResponse.data.customer,
                isLoading: false,
            },
                function () {
                    var data = [];
                    console.log("BUG", this.state.mtnAnalysis)
                    if (this.state.mtnAnalysis.length > 0) {
                        for (let i = 0; i < this.state.mtnAnalysis.length; i++) {

                            let totalhits = { mTotalHits: this.state.mtnAnalysis[i].TotalHits.toString() }

                            let mTotalDepositsAttempted = { mTotalDepositsAttempted: this.state.mtnAnalysis[i].TotalDepositsAttempted.toString() }


                            let mSuccessfulDeposits = { mSuccessfulDeposits: this.state.mtnAnalysis[i].SuccessfulDeposits.toString() }

                            let mSuccessful = { mSuccessful: this.state.mtnAnalysis[i].Successful.toString() }

                            let mFailedDeposits = { mFailedDeposits: this.state.mtnAnalysis[i].FailedDeposits.toString() }

                            let mInsufficientFunds = { mInsufficientFunds: this.state.mtnAnalysis[i].InsufficientFunds.toString() }

                            let perCancelledDeposits = { perCancelledDeposits: this.state.mtnAnalysis[i].percentCancelledDeposits.toString() }

                            let mInitiatedDeposits = { mInitiatedDeposits: this.state.mtnAnalysis[i].InitiatedDeposits.toString() }
                            let mTimedOutDeposits = { mTimedOutDeposits: this.state.mtnAnalysis[i].TimedOutDeposits.toString() }



                            let totalCancelledDeposits = { totalCancelledDeposits: this.state.mtnAnalysis[i].mCancelledDeposits.toString() }

                            let date = { dates: moment.utc(this.state.mtnAnalysis[i].DATE).format("DD-MMM-yyyy") };
                            data.push(Object.assign(
                                date,
                                totalhits,
                                mTotalDepositsAttempted,
                                mSuccessfulDeposits,
                                totalCancelledDeposits,
                                mFailedDeposits,
                                mSuccessful,
                                mInsufficientFunds,
                                perCancelledDeposits,
                                mInitiatedDeposits,
                                mTimedOutDeposits,
                                this.state.mtnAnalysis[i]));
                            this.setState({
                                data: data,
                                isLoading: false
                            })
                            console.log("bugs", data);
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false
                        })
                        console.log("bugs", data);
                    }
                }
            );
        }))

    }


    applyCallback(startDate, endDate) {

        let Sdate1 = moment.utc(startDate).format('DD MMM, YYYY');
        let Edate2 = moment.utc(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })

        this.getData(moment.utc(startDate).format('YYYY-MM-DD'), moment.utc(endDate).format('YYYY-MM-DD'));
    }


    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }

    getDataUpdate() {
        let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")

        this.getData(moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    render() {
        let ranges = {
            "Today Only": [moment.utc(this.state.start), moment.utc(this.state.end)],
            "Yesterday Only": [
                moment.utc(this.state.start).subtract(1, "days"),
                moment.utc(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment.utc(this.state.start).subtract(3, "days"), moment.utc(this.state.end)],
            "5 Days": [moment.utc(this.state.start).subtract(5, "days"), moment.utc(this.state.end)],
            "1 Week": [moment.utc(this.state.start).subtract(7, "days"), moment.utc(this.state.end)],
            "2 Weeks": [moment.utc(this.state.start).subtract(14, "days"), moment.utc(this.state.end)],
            "1 Month": [moment.utc(this.state.start).subtract(1, "months"), moment.utc(this.state.end)],
            "1 Year": [moment.utc(this.state.start).subtract(1, "years"), moment.utc(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY",
            "sundayFirst": false
        }


        return (
            <div >
                < >
                    <h4>MTN Deposits Analysis</h4>
                    < Card >
                        <CardBody >
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <DateTimeRangeContainer
                                                    ranges={ranges}
                                                    start={this.state.start}
                                                    end={this.state.end}
                                                    local={local}
                                                    applyCallback={this.applyCallback}>
                                                    <FormControl
                                                        id="formControlsTextB"
                                                        type="text"
                                                        value={this.state.valuedate}
                                                        label="Text"
                                                        placeholder="Filter by Date"
                                                    />
                                                </DateTimeRangeContainer>
                                            </div>
                                            <div className="col-6 float-left">

                                                <button className=" float-left btn btn-primary btn-sm" onClick={e => {
                                                    this.getDataUpdate();
                                                    this.setState({
                                                        startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        valuedate: "Today"
                                                    })
                                                }} >Clear</button>
                                                {/* <input id="input" type="text" readOnly /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                </div>
                            </div><br />
                            <div className="panel-body" >
                                {this.state.isShowError ?
                                    <div className="alert alert-success" > {this.state.statusMessage}
                                    </div> : null
                                }
                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.data}
                                    columns={this.columns}
                                    dynamic={true}
                                    id="tsc"
                                    loading={this.state.isLoading}
                                    total_record={this.state.mdata}
                                    onChange={this.tableChangeHandler} />
                            </div>
                        </CardBody>

                    </Card>
                </>
            </div>

        )
    }
}